import useLazyX from 'src/internal/hooks/useLazyX';

import type Registry from 'src/internal/Registry';
import type {CommonValues, Extra} from 'src/internal/types';

export default function useX<
  TValues extends {[key: string]: unknown},
  TName extends keyof TValues,
>(
  registry: Registry<TValues>,
  values: TValues,
  fallback: CommonValues<TValues>,
  name: TName,
  extra?: Extra,
): TValues[TName] | CommonValues<TValues> {
  return useLazyX(registry, values, fallback)(name, extra);
}
